import { Button } from "./Button";

export class EnterHypoButton extends Button {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setLeft: (this: EnterHypoButton) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setCenter: (this: EnterHypoButton) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setRight: (this: EnterHypoButton) => void = () => {};
}
